import $ from 'jquery';
import Player from '@vimeo/player';
import 'waypoints/lib/noframework.waypoints.min';

let youTubeApi;

function loadYouTubeApi() {
    if (!youTubeApi) {
        youTubeApi = new Promise((resolve) => {
            if (window.YT && window.YT.Player) {
                resolve(window.YT);
                return;
            }

            const previousReady = window.onYouTubeIframeAPIReady;

            window.onYouTubeIframeAPIReady = function () {
                if (previousReady) previousReady();
                resolve(window.YT);
            };

            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
        });
    }

    return youTubeApi;
}

// YouTube switches auto-generated captions on for some videos regardless of the video's own settings.
// There is no supported embed parameter to stop that, so drop the captions module on first
// play. unloadModule is undocumented; viewers can still turn captions back on via the CC button.
function hideYouTubeCaptions(iframe) {
    loadYouTubeApi().then((YT) => {
        let captionsHidden = false;

        new YT.Player(iframe, {
            events: {
                onStateChange: function (event) {
                    if (!captionsHidden && event.data === YT.PlayerState.PLAYING) {
                        event.target.unloadModule('captions');
                        captionsHidden = true;
                    }
                },
            },
        });
    });
}

export default class Video {
    constructor() {
        if ($('.js-video').length) {
            $('.js-video__play-button').on('click', function () {
                const $this = $(this);
                const $parent = $this.closest('.js-video');
                const $videoWrapper = $parent.find('.js-video__video');
                const videoSource = $videoWrapper.data('source');
                const $video = $videoWrapper.find('iframe');
                let width;
                let height;

                if (videoSource == 'vimeo') {
                    const player = new Player($video[0]);

                    Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function (dimensions) {
                        width = dimensions[0];
                        height = dimensions[1];

                        if (height > width && Foundation.MediaQuery.is('small only')) {
                            $videoWrapper.removeClass('widescreen').addClass('portrait');
                        }

                        $this.fadeOut();
                        $parent.find('.js-video__overlay-title').fadeOut();

                        player.play();
                    });
                } else {
                    const src = new URL($video.attr('src'));

                    src.searchParams.set('autoplay', '1');
                    // Required for the iframe API to control an existing embed
                    src.searchParams.set('enablejsapi', '1');
                    src.searchParams.set('origin', window.location.origin);
                    $video.attr('src', src.toString());

                    $this.fadeOut();
                    $parent.find('.js-video__overlay-title').fadeOut();

                    $videoWrapper.html($video);

                    hideYouTubeCaptions($video[0]);
                }
            });

            // Loop through each instance of the video block and check if it has the 'has-autoplay' class
            $('.js-video').each(function () {
                const $this = $(this);

                if ($this.hasClass('has-autoplay')) {
                    const $video = $this.find('.js-video__video iframe');
                    const player = new Player($video[0]);

                    player.setMuted(true);

                    new Waypoint({
                        element: $this[0],
                        handler: function () {
                            $this.find('.js-video__play-button').fadeOut();
                            $this.find('.js-video__overlay-title').fadeOut();

                            player.play();
                        },
                        offset: 'bottom-in-view',
                    });
                }
            });
        }
    }
}
